import { validateNode as validateEditCode } from 'slate-edit-code/dist/validation';

import {
  NODE_TYPE as NT,
} from 'shared/constants/slate';

import {
  MakeRuleMustNotHaveMarks,
  MakeRuleNoWhitespaceAtStart,
  MakeRuleNoMultipleWhitespaces,
  MakeRuleUnsetOrphanCodeLine,
  ensureEndingParagraphToNavigate,
  ensureNoTrailingEmptyBlocks,
  ensureNoOrphanReceiver,
} from './rules'


// Convert an old rule definition to an
// individual plugin with on "validateNode"
const toValidateNode = (rule) => {
  const validateRule = (node) => {
    if (!rule.match(node)) {
      return undefined;
    }
    const validationResult = rule.validate(node);
    if (validationResult == null) {
      return undefined;
    }

    return change => rule.normalize(change, node, validationResult);
  };

  return validateRule;
};

const validateNodeWithRules = (rules = []) => {
  const validators = rules.map(toValidateNode);

  return (node) => {
    let changer;
    validators.find(validator => {
      changer = validator(node);
      return Boolean(changer);
    });

    return changer;
  };
};



/*
 * Headline
 */
const matchHeadline = node => node.type === NT.headline;
const validateHeadline = validateNodeWithRules([
  MakeRuleNoWhitespaceAtStart({ matcher: matchHeadline }),
  MakeRuleMustNotHaveMarks({ matcher: matchHeadline }),
]);


/*
 * Paragraph
 */
const matchParagraph = node => node.type === NT.paragraph;
const validateParagraph = validateNodeWithRules([
  MakeRuleNoWhitespaceAtStart({matcher: matchParagraph}),
  MakeRuleNoMultipleWhitespaces({matcher: matchParagraph}),
]);


/*
 * Receiver (Image, Embed)
 */
const validateReceiver = validateNodeWithRules([
  ensureNoOrphanReceiver,
]);


/*
 * Document
 */
const validateDocument = validateNodeWithRules([
  ensureEndingParagraphToNavigate,
]);


/*
 * Preview
 */
const validatePreview = validateNodeWithRules([
  ensureNoTrailingEmptyBlocks,
]);


/*
 * CodeBlock
 * XXX: Not used anymore..?
 */
const validateEditCodeMore = (opts) => {
  const rule = MakeRuleUnsetOrphanCodeLine(opts);
  const validator = toValidateNode(rule);
  const moreValidators = validateEditCode(opts)

  return (node) => {
    const changer = validator(node);

    return (changer
      ? changer
      : moreValidators(node)
    );
  };
};



export {
  validateDocument,
  validateHeadline,
  validateParagraph,
  validateReceiver,
  validatePreview,

  validateEditCodeMore,
}



// WEBPACK FOOTER //
// ./src/components/slate/validations.js